import { makeStyles } from "@mui/styles";
import { createTheme } from '@mui/material/styles';
const theme = createTheme();

const useFinalScore = makeStyles(() => ({
  container: {
    width: "90%",
    maxWidth: "1200px",
    margin: "2rem auto",
    textAlign: "center",
    "& .MuiTypography-caption": {
      fontFamily: "Jost",
      fontSize: "1.2rem",
      fontWeight: "500",
      color: "#223852",
      textTransform: "uppercase",
      [theme.breakpoints.down("md")]: {
        fontSize: "1rem",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "0.85rem",
      },
    },
    "& .MuiTypography-h6": {
      fontFamily: "Jost",
      fontSize: "1.5rem",
      fontWeight: "700",
      color: "#223852",
      [theme.breakpoints.down("md")]: {
        fontSize: "1.3rem",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "1.1rem",
      },
    },
    [theme.breakpoints.down("sm")]: {
      margin: "1rem auto",
      width: "95%",
    },
  },
  imageContainer: {
    margin: "0 auto",
    "& img": {
      maxWidth: "100%",
      height: "auto",
      [theme.breakpoints.down("md")]: {
        width: "300px",
      },
      [theme.breakpoints.down("sm")]: {
        width: "220px",
      },
    }
  },
  yourScore: {
    margin: "1.5rem auto",
    background: "#f8f9fa",
    width: "fit-content",
    minWidth: "200px",
    padding: "1rem 2rem",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    [theme.breakpoints.down("sm")]: {
      width: "80%",
      minWidth: "160px",
      padding: "0.8rem 1rem",
    },
  },
  incorrectCorrectTime: {
    display: "flex",
    justifyContent: "center",
    alignItems: "stretch",
    margin: "2rem 0",
    [theme.breakpoints.down("sm")]: {
      flexWrap: "wrap",
      margin: "1rem 0",
      gap: "15px",
    },
  },
  scoreItem: {
    padding: "0.5rem",
    [theme.breakpoints.down("sm")]: {
      flex: "1 1 40%",
      minWidth: "120px",
    },
  },
  divider: {
    margin: "0 2rem",
    [theme.breakpoints.down("md")]: {
      margin: "0 1rem",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  dividerlst: {
    margin: "0 2rem",
    [theme.breakpoints.down("md")]: {
      margin: "0 1rem",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none"
    },
  },
  timetakencont: {
    padding: "0.5rem",
    [theme.breakpoints.down("sm")]: {
      flex: "1 1 40%",
      minWidth: "120px",
    },
  },
}));

export default useFinalScore;
